
import a from "../assets/img/meet/02.jpg";
import b from "../assets/img/meet/05.jpg";
import c from "../assets/img/meet/06.jpg";
import d from "../assets/img/meet/07.jpg";
import e from "../assets/img/meet/08.jpg";

export const list = [a, b, c, d, e ];
